setTimeout(() => {
    window.KC.renderDC();
    window.KC.renderNT();
}, 1000);

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[bss-b2b-btn-quickview]");
  if (!btn) return;

  setTimeout(() => {
      document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
  }, 1000);
});

let isFirstClick = true;

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".product-option__input");
  if (!btn) return;

  if (isFirstClick) {
    setTimeout(() => {
        document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
    }, 300);
    isFirstClick = false;
  } else {
    const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
    if (!productForm) return;
    setTimeout(() => {
        BSS_B2B?.observer?.productSubject?.notifyObserver(
        "VariantChange",
        "VariantSelectChange",
        { productForm }
        );
    }, 300);
  }
});